import React, { memo } from "react";

import {
  VehicleImageContainerStyled,
  VehicleImageBgStyled,
  VehicleImageStyled,
  TitleBatteryStyled,
  VehicleNameStyled,
  BatteryContainerStyled,
} from "../../styles";
import { BatteryIndicator } from "../BatteryIndicator/BatteryIndicator";

export interface VehicleInfoProps {
  name: string;
  imageUrl?: string;
  batteryPercent: number; // 0-100 (raw percentage from vehicle.batteryLevel)
}

export const VehicleInfo = memo<VehicleInfoProps>(
  ({ name, imageUrl, batteryPercent }) => {
    return (
      <>
        <VehicleImageContainerStyled data-test-id="vehicle-info-image-container">
          <VehicleImageBgStyled />
          {imageUrl && (
            <VehicleImageStyled
              src={imageUrl}
              alt={name}
              data-test-id="vehicle-info-image"
            />
          )}
        </VehicleImageContainerStyled>

        <TitleBatteryStyled>
          <VehicleNameStyled data-test-id="vehicle-info-name">
            {name}
          </VehicleNameStyled>
          <BatteryContainerStyled data-test-id="vehicle-info-battery-container">
            <BatteryIndicator percent={batteryPercent} />
          </BatteryContainerStyled>
        </TitleBatteryStyled>
      </>
    );
  }
);

VehicleInfo.displayName = "VehicleInfo";
